export default __webpack_public_path__ + "static/media/error.eba3b84a.svg";